export default {
  createButton: { id: 'create_button' },
  saveInfo: { id: 'save_info' },
  changePassword: { id: 'change_password' },
  setPassword: { id: 'set_password' },
  oldPassword: { id: 'old_password' },
  newPassword: { id: 'new_password' },
  confirmPassword: { id: 'confirm_password' },
  change: { id: 'change' },
  language: { id: 'language' },
  name: { id: 'name' },
  email: { id: 'email' },
  notifications: { id: 'notifications' },
  editAvatar: { id: 'edit_avatar' },
  profileAvatar: { id: 'profile_avatar' },
  profileWasUpdated: { id: 'profile_was_updated' },
  settings: { id: 'settings' },
  personalInfo: { id: 'personal_info' },
  myNotifications: { id: 'my_notifications' },
  personalSettings: { id: 'personal_settings' },
  save: { id: 'save' },
  cancel: { id: 'cancel' },
  password: { id: 'password' },
  contacts: { id: 'contacts' },
  mobilePhone: { id: 'mobile_phone' },
  localeExplanationText: { id: 'locale_explanation_text' },
  allowNotifications: { id: 'allow_notifications' },
  notificationPreferences: { id: 'notification_preferences' },
  jobs_job_created: { id: 'is_created' },
  jobs_job_started: { id: 'is_started' },
  jobs_job_task_assigned: { id: 'task_reassigned' },
  jobs_job_overdue: { id: 'overdue' },
  jobs_job_completed: { id: 'completed' },
  jobs_job_reopened: { id: 'is_reopened' },
  jobs_job_sent_for_review: { id: 'is_sent_for_review' },
  jobs_job_sent_back_from_review: { id: 'is_sent_back_from_review' },
  mna_alert_appeared: { id: 'critical_alerts' },
  jobs: { id: 'jobs' },
  monitorsAndAlerts: { id: 'monitors_and_alerts' },
  sms: { id: 'sms' },
  delete: { id: 'delete' },
  deleteUser: { id: 'delete_user' },
  deleteUserMessage: { id: 'delete_user_message' },
  deleteAccount: { id: 'delete_account' },
  signature: { id: 'signature' },
  deleteSuccessMessage: { id: 'delete_success_message' },
  deleteSignatureMessage: { id: 'delete_signature_message' },
  enterNamePlaceholder: { id: 'enter_name_placeholder' },
}
